import Axios from '../components/Axios'

export const getBlogList = (update) => {
	return Axios('POST', 'officialWeb/getBlogList', update)
}


export const getBlogInfo = (id) => {
	return Axios('GET', `officialWeb/getBlogInfo/${id}`)
}
